// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rs-picker-toggle-value{\n    color: hsl(0, 0%, 20%) !important;\n}", "",{"version":3,"sources":["webpack://./src/assets/css/inputs/rsuite-select-picker.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;AACrC","sourcesContent":[".rs-picker-toggle-value{\n    color: hsl(0, 0%, 20%) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
